import * as React from "react";
import { markdown, ReactSpecimen } from "catalog";
import { SearchResultsGrid } from "./SearchResultsGrid";
export default () => markdown `

## Search Results Grid

The search results grid updates when the user selects a dataset or a tag in the header.
The grid is based on [\`react-virtualized\`](https://github.com/bvaughn/react-virtualized/tree/master/docs): only the cards in the viewport are displayed, and the grid updates when the user scrolls.
Because \`react-virtualized\` uses \`PureComponent\` and \`shallowCompare\`, the prop \`resultsCount\` must be passed to \`<SearchResultsGrid />\` in order to force the \`react-virtualized\` components stack to update (\`<WindowScroller />\`, \`<AutoSizer />\` and \`<Masonry />\`). See the [docs](https://github.com/bvaughn/react-virtualized#pure-components).

${(<ReactSpecimen responsive>
    <div style={{ width: "100%" }}>
      <SearchResultsGrid searchResults={[
    { id: "1", label: "Bevölkerung" },
    { id: "2", label: "Arbeit" },
    { id: "3", label: "Ausland" },
    { id: "4", label: "Branche" },
    { id: "5", label: "Alter der Mutter" },
    { id: "6", label: "Ausbildungsniveau" },
    { id: "7", label: "Bruttogescholssfläche" },
    { id: "8", label: "Brutto-Rücklaufquote" },
    { id: "9", label: "Bevölkerungsbilanz" },
    { id: "10", label: "Aufenthaltskategorie" },
    { id: "11", label: "Ausbildungsverkehr" }
]} resultsCount={11} page="search"/>
    </div>
  </ReactSpecimen>)}

`;



// WEBPACK FOOTER //
// ./src/components/SearchResultsGrid.docs.tsx